import Reveal from './Reveal';

document.addEventListener('DOMContentLoaded', () => {
  const $reveals = document.querySelectorAll('[data-reveal]');
  if (!$reveals.length) {
    return;
  }
  $reveals.forEach(($reveal) => {
    const reveal = new Reveal($reveal);
    reveal.mount();
  });
});
